import { axiosInstance, axiosRequestWithAuth } from '../../constants/server.constant';

const getUserId = () => {
    return localStorage.getItem("userId");
};

const getLoadBalList = async (isNonCached) => {
    try {
        return await axiosInstance.get("/loadbal/list/" + getUserId() + "?isNonCached=" + isNonCached, axiosRequestWithAuth);
    }
    catch(error) {
        console.log(error);
        return false;
    }
};

const showLoadBalancerDetails = async (region, loadBalancerId) => {
    try {
        return await axiosInstance.get("/loadbal/showlb/" + region + "/" + getUserId() + " /" + loadBalancerId);
    }
    catch(error) {
        console.log(error);
        return false;
    }
};

const createLoadBalancer = async (region, data) => {
    try {
        return await axiosInstance.post("/loadbal/createloadbalancer/" + getUserId() + "?region=" + region, data, axiosRequestWithAuth);
    }
    catch(error) {
        console.log(error);
    }
};


const updateLoadBalancerData = async (data) => {
    try {
        let resp = await axiosInstance.put("/loadbal/updatelb/" + getUserId(), data, axiosRequestWithAuth);
        console.log(resp);
        return resp.data;
    }
    catch(error) {
        console.log(error);
        return false;
    }
};

const getLoadBalDefaultConfig = async (id, region) => {
    try {
        return await axiosInstance.get("/loadbal/getloadbaldata/" + getUserId() + "?loadBalId=" + id + "&region=" + region, axiosRequestWithAuth)
            .then(resp => {
                return resp.data;
            })
            .catch(error => {
                return false;
            });
    }
    catch(error) {
        console.log(error);
        return false;
    }
};

const deleteLoadBalancer = async (id, region) => {
    try {
        return await axiosInstance.delete("/loadbal/deletelb/" + getUserId() + "?loadBalId=" + id + "&region=" + region, axiosRequestWithAuth)
            .then(resp => {
                return resp;
            })
            .catch(error => {
                return false;
            });
    }
    catch(error) {
        console.log(error);
        return false;
    }
};

const LoadBalancerService = {
    getUserId,
    showLoadBalancerDetails,
    getLoadBalList,
    updateLoadBalancerData,
    getLoadBalDefaultConfig,
    deleteLoadBalancer
};

export default LoadBalancerService;

